import {ListItem, Modal, Tab, Tabs, Typography} from '@mui/material';
import {Box} from '@mui/system';
import {ReactNode, useState} from 'react';

import {MapItemUpload} from '../MapItemUpload';
import {MapSourceUpload} from '../MapSourceUpload';

interface MapItemUploadButtonProps {
  component?: React.FC;
  componentProps?: any;
  onSubmitted?: () => void;
  children?: ReactNode;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: {xs: '95%', md: 1100},
  bgcolor: 'background.paper',
  border: '1px solid #9b9b9b',
  boxShadow: 24,
  p: 3,
  overflow: 'auto',
  maxHeight: '100%',
};

export const MapItemUploadButton: React.FC<MapItemUploadButtonProps> = ({
  component = ListItem,
  componentProps = {},
  children,
  onSubmitted,
}) => {
  const Component = component;

  const [isOpened, setIsOpened] = useState(false);
  const [tab, setTab] = useState(0);

  const openModal = () => setIsOpened(true);
  const closeModal = () => setIsOpened(false);

  const handleSubmitted = () => {
    onSubmitted?.();
    closeModal();
  };

  return (
    <>
      <Component {...componentProps} onClick={openModal}>
        {children}
      </Component>

      <Modal open={isOpened} onClose={closeModal}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" sx={{mb: 2}}>
            Upload Map
          </Typography>

          <Tabs
            value={tab}
            sx={{mb: 2}}
            onChange={(__, value) => setTab(value)}
          >
            <Tab label="Map image" />
            <Tab label="Tiled archive" />
          </Tabs>

          {tab === 0 ? (
            <MapSourceUpload
              onCancel={closeModal}
              onSubmitted={handleSubmitted}
            />
          ) : (
            <MapItemUpload
              onCancel={closeModal}
              onSubmitted={handleSubmitted}
            />
          )}
        </Box>
      </Modal>
    </>
  );
};
